var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    key: _vm.currentLanguage,
    class: ['tui-chat', !_vm.isPC && 'tui-chat-h5', 'ai-desk-customer']
  }, [_vm.currentConversationID && (!_vm.props.showQueuePage || _vm.queueNumber < 0 || _vm.queueNumber === undefined || _vm.hasLeftQueue) ? _c('div', {
    class: ['tui-chat', !_vm.isPC && 'tui-chat-h5', 'ai-desk-customer']
  }, [_c('ChatHeader', {
    class: ['tui-chat-header', !_vm.isPC && 'tui-chat-H5-header'],
    attrs: {
      "canCloseChat": _vm.props.canCloseChat,
      "enableMultilingual": _vm.props.enableMultilingual,
      "langList": _vm.languageForShowList,
      "currentLang": _vm.currentLanguage,
      "headerConfig": _vm.props.headerConfig
    },
    on: {
      "closeChat": _vm.closeChat,
      "changeLanguage": _vm.changeLanguage
    }
  }), _c('MessageList', {
    ref: "messageListRef",
    class: ['tui-chat-message-list', !_vm.isPC && 'tui-chat-h5-message-list'],
    attrs: {
      "bottomQuickOrder": _vm.props.bottomQuickOrder,
      "showBottomQuickOrder": _vm.showBottomQuickOrder,
      "enableFeedback": _vm.props.enableFeedback,
      "enableAINote": _vm.props.enableAINote,
      "enableFileMediaPreview": _vm.props.enableFileMediaPreview
    },
    on: {
      "handleEditor": _vm.handleEditor,
      "closeInputToolBar": function () {
        return _vm.changeToolbarDisplayType('none');
      },
      "closeBottomQuickOrder": _vm.closeBottomQuickOrder,
      "like": _vm.onLike,
      "dislike": _vm.onDislike
    }
  }), _vm.props.toolbarButtonList && (!_vm.isH5 || !Boolean(_vm.quoteMessage) && !_vm.showBottomQuickOrder) ? _c('MessageToolbarButton', {
    attrs: {
      "toolbarButtonList": _vm.props.toolbarButtonList
    }
  }) : _vm._e(), _vm.isInputToolbarShow ? _c('MessageInputToolbar', {
    class: ['tui-chat-message-input-toolbar', !_vm.isPC && 'tui-chat-h5-message-input-toolbar'],
    attrs: {
      "displayType": _vm.inputToolbarDisplayType,
      "inputToolbarList": _vm.props.inputToolbarList
    },
    on: {
      "insertEmoji": _vm.insertEmoji,
      "changeToolbarDisplayType": _vm.changeToolbarDisplayType,
      "scrollToLatestMessage": _vm.scrollToLatestMessage
    }
  }) : _vm._e(), _c('MessageInput', {
    ref: "messageInputRef",
    class: ['tui-chat-message-input', !_vm.isPC && 'tui-chat-h5-message-input'],
    attrs: {
      "isMuted": _vm.isMuted,
      "muteText": _vm.muteText,
      "placeholder": _vm.TUITranslateService.t('TUIChat.请输入消息'),
      "inputToolbarDisplayType": _vm.inputToolbarDisplayType,
      "inputToolbarList": _vm.props.inputToolbarList,
      "enableSendingAudio": _vm.props.enableSendingAudio
    },
    on: {
      "changeToolbarDisplayType": _vm.changeToolbarDisplayType,
      "emojiShow": _vm.emojiShow,
      "toolShow": _vm.toolShow,
      "blurToolAndEmojiH5": _vm.blurToolAndEmojiH5,
      "messageSent": _vm.onMessageSent
    }
  }), _c('div', {
    staticClass: "input-toolbar-h5"
  }, [_c('div', {
    class: ['emoji-dialog-h5', _vm.toolShowH5 && !_vm.emojiOpen ? 'tool-dialog-h5' : '']
  }, [_vm.emojiOpen ? _c('div', [_c('EmojiDialog', {
    on: {
      "insertEmoji": _vm.insertEmoji,
      "sendMessage": _vm.sendMessage
    }
  })], 1) : _vm._e(), !_vm.isPC ? _c('MessageInputToolbar', {
    class: ['tui-chat-message-input-toolbar', !_vm.isPC && 'tui-chat-h5-message-input-toolbar'],
    attrs: {
      "isH5ToolShow": _vm.toolShowH5,
      "displayType": _vm.inputToolbarDisplayType,
      "inputToolbarList": _vm.props.inputToolbarList
    },
    on: {
      "insertEmoji": _vm.insertEmoji,
      "changeToolbarDisplayType": _vm.changeToolbarDisplayType,
      "scrollToLatestMessage": _vm.scrollToLatestMessage,
      "sendMessage": _vm.sendMessage
    }
  }) : _vm._e()], 1)]), _c('FeedbackModal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showFeedbackModal,
      expression: "showFeedbackModal"
    }],
    ref: "feedbackModalRef",
    on: {
      "close": function () {
        _vm.showFeedbackModal = false;
      }
    }
  })], 1) : _vm._e(), _vm.props.showQueuePage && _vm.queueNumber >= 0 && !_vm.hasLeftQueue ? _c('div', {
    class: ['tui-chat', !_vm.isPC && 'tui-chat-h5']
  }, [_c('CustomerQueuePage', {
    attrs: {
      "queueNumber": _vm.queueNumber
    },
    on: {
      "closeQueuePage": _vm.closeQueuePage
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }